const getHook = () => {
    return `    
    //This code will allows to get information from the AuthContext
    import { useContext } from 'react';
    import AuthContext from '../CustomContext';

    const useAuth = () => useContext(AuthContext);
    export default useAuth;`
};

export default getHook;
